export default "__VITE_ASSET__38i85lqU__"